import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import SEOHead from "@/components/SEOHead";

const Termos = () => {
  return (
    <div className="bg-background min-h-screen">
      <SEOHead
        title="Termos e Condições | EVK"
        description="Termos e condições de utilização do website evk.pt."
        canonical="https://evk.pt/termos"
      />
      <Navbar />
      <div className="container mx-auto px-6 lg:px-12 pt-28 pb-24 max-w-3xl">
        <h1 className="font-serif text-4xl md:text-5xl text-foreground mb-8">
          Termos e Condições
        </h1>
        <p className="text-xs text-muted-foreground mb-12">
          Última atualização: Abril 2026
        </p>

        <div className="space-y-8 text-sm text-muted-foreground leading-relaxed">
          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">1. Identificação</h2>
            <p>
              O presente website é propriedade da EVK — Thinkers & Makers, com sede em TABpark — Zona Industrial da Taboeira, Lote 27, Fração H1, 3800-055 Aveiro, Portugal.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">2. Objeto</h2>
            <p>
              Os presentes Termos e Condições regulam o acesso e utilização do website evk.pt, bem como os serviços disponibilizados através do mesmo.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">3. Propriedade Intelectual</h2>
            <p>
              Todos os conteúdos presentes neste website, incluindo textos, imagens, logótipos, gráficos e software, são propriedade da EVK ou dos seus licenciantes e estão protegidos por legislação de propriedade intelectual.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">4. Utilização do Website</h2>
            <p>
              O utilizador compromete-se a utilizar o website de forma lícita, não devendo utilizá-lo para fins ilícitos ou que possam danificar, desabilitar, sobrecarregar ou deteriorar o mesmo.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">5. Limitação de Responsabilidade</h2>
            <p>
              A EVK não se responsabiliza por quaisquer danos diretos ou indiretos resultantes da utilização ou impossibilidade de utilização deste website.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">6. Links Externos</h2>
            <p>
              Este website poderá conter links para websites de terceiros. A EVK não se responsabiliza pelo conteúdo ou pelas práticas de privacidade desses websites.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">7. Legislação Aplicável</h2>
            <p>
              Os presentes Termos e Condições são regidos pela legislação portuguesa. Para resolução de qualquer litígio será competente o foro da comarca de Aveiro.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl text-foreground mb-3">8. Contacto</h2>
            <p>
              Para questões relacionadas com os presentes Termos e Condições, contacte-nos através de{" "}
              <a href="mailto:geral@evoke.pt" className="text-accent hover:underline">geral@evoke.pt</a>.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft size={16} /> Voltar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Termos;
